export const MODALS = {
    FEATURES: 'FEATURES',
    EDIT_PRICE: 'EDIT_PRICE',
}
